var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import React, { PureComponent } from 'react';
import { defaultProps } from './defaults';
import { omit } from '../../Utils/object';
import { LockOutlined, UnlockOutlined } from '@feb-team/legao-icons-react';
import { DivTag, InputTag, SpanTag } from '../../Utils/AtomicTag';
// 防止受控和非受控转换时报错
function fixControlledValue(value) {
    if (typeof value === 'undefined' || value === null) {
        return '';
    }
    return value;
}
var Password = /** @class */ (function (_super) {
    __extends(Password, _super);
    function Password(props) {
        var _this = _super.call(this, props) || this;
        _this.setValue = function (value, e, callback) {
            if (!('value' in _this.props)) {
                _this.setState({ value: value }, callback);
            }
            var onChange = _this.props.onChange;
            if (onChange) {
                var event_1 = e;
                onChange(value, event_1);
            }
        };
        _this.handleChange = function (e) {
            _this.setValue(e.target.value, e);
        };
        // 切换显示/隐藏密码
        _this.handleTogglePassword = function () {
            var iconName = _this.state.iconName;
            _this.setState({
                iconName: iconName === 'lock' ? 'unlock' : 'lock',
            });
        };
        var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
        _this.state = {
            value: value,
            iconName: 'lock',
        };
        return _this;
    }
    Password.getDerivedStateFromProps = function (nextProps) {
        if ('value' in nextProps) {
            return {
                value: nextProps.value,
            };
        }
        return null;
    };
    Password.prototype.render = function () {
        var _a = this.props, className = _a.className, style = _a.style, size = _a.size, disabled = _a.disabled, visibilityToggle = _a.visibilityToggle;
        var _b = this.state, iconName = _b.iconName, value = _b.value;
        var iptBox = [
            'relative',
            'w-px-220',
            'bg-white',
            'box-border',
            'rounded',
            'flex',
        ];
        var ipt = [
            'pl-px-12',
            'pr-px-40',
            'w-full',
            'border',
            'border-solid',
            'border-gray-300',
            'rounded',
            'hover:border-brand-600',
            'focus:border-brand-600',
            'text-gray-700',
        ];
        // 密码框的禁用/启用样式
        if (disabled) {
            ipt.push('cursor-not-allowed', 'hover:border-gray-300', 'text-gray-400', 'bg-gray-100');
        }
        else {
            ipt.push('hover:border-brand-600', 'focus:border-brand-600', 'text-gray-700', 'focus:shadow-input');
        }
        var setClsObj = {
            small: {
                box: ['h-6'],
            },
            large: {
                box: ['h-10'],
            },
            normal: {
                box: ['h-8'],
            },
        };
        var togglePasswordClass = [
            'absolute',
            'right-0',
            'left-auto',
            'w-px-14',
            'h-px-14',
            'cursor-pointer',
            'leading-none',
            'text-gray-400',
            'top-half',
            'mr-px-12',
            '-mt-px-7',
            'text-sm',
        ];
        var otherProps = omit(this.props, [
            'leftAddon',
            'rightAddon',
            'onBeforeEnter',
            'onEnter',
            'defaultValue',
            'size',
            'visibilityToggle',
            'searchText',
            'className',
            'style',
        ]);
        return (React.createElement(DivTag, { name: Password.NAME, atomics: iptBox, className: className, style: style }, iconName === 'unlock' ? (React.createElement(React.Fragment, null,
            React.createElement(InputTag, __assign({ type: "text" }, otherProps, { value: fixControlledValue(value), disabled: disabled, onChange: this.handleChange, atomics: __spread(ipt, setClsObj[size].box) })),
            visibilityToggle && (React.createElement(SpanTag, { atomics: togglePasswordClass, autoPrefixedClassName: "password-unlock" },
                React.createElement(UnlockOutlined, { onClick: this.handleTogglePassword }))))) : (React.createElement(React.Fragment, null,
            React.createElement(InputTag, __assign({ type: "password" }, otherProps, { value: fixControlledValue(value), disabled: disabled, onChange: this.handleChange, atomics: __spread(ipt, setClsObj[size].box) })),
            visibilityToggle && (React.createElement(SpanTag, { atomics: togglePasswordClass, autoPrefixedClassName: "password-lock" },
                React.createElement(LockOutlined, { onClick: this.handleTogglePassword })))))));
    };
    Password.defaultProps = defaultProps;
    Password.NAME = 'password';
    Password.displayName = 'Password';
    return Password;
}(PureComponent));
export { Password };
